import SiteHeader from "./SiteHeader";
import { Link } from "react-router-dom";
import "../styles/components/HomePage.css";
import laptopImage from "../assets/laptop.jpg";
import bottlesImage from "../assets/bottles.jpg";
import venueImage from "../assets/venue.jpg";

const HOTEL_BOOKING_URL =
  "https://www.marriott.com/event-reservations/reservation-link.mi?id=1767199105113&key=GRP&app=resvlink&_branch_match_id=1239728187785132198&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXTywo0MtNLCrKzC8p0UvOz9UvSi3OzczLtgdK2ALZZSCOWmaKraG5mbmhpaWhgamhobFadmqlrXtQgFpdUWpaKlB3Xnp8UlF%2BeXFqka1zRlF%2BbioAakEdOWAAAAA%3D";

const whatToExpect = [
  "Engaging perspectives on the consumer and market forces shaping our business",
  "Meaningful opportunities to connect and collaborate as thought partners",
  "Inspiring, experiential moments that spark new ideas and translate insight into action",
  "A celebration of distributor partners whose leadership and execution continue to raise the bar",
];

const keyProgramMoments = [
  { date: "TUESDAY, MARCH 10", detail: "6:00 - 8:00 PM Inside Luxury: An LVMH Experience" },
  {
    date: "WEDNESDAY, MARCH 11",
    detail: "Full-day Conference & Evening Recognition Ceremony",
  },
  { date: "THURSDAY, MARCH 12", detail: "Conference concludes at 3:00 PM" },
];

export default function HomePage() {
  return (
    <div className="home">
      <SiteHeader />

      <main className="home__main">
        <section className="home__hero">
          <div className="container home__heroInner">
            <div className="home__heroCopy">
              <div className="home__heroKicker">
                2026 MOËT HENNESSY
                <br />
                DISTRIBUTOR CONFERENCE
              </div>

              <h1 className="home__heroTitle">Future Forward</h1>

              <div className="home__heroRule" aria-hidden="true" />

              <div className="home__heroMeta" aria-label="Dates and location">
                <div className="home__heroMetaLine">March 10-12, 2026</div>
                <div className="home__heroMetaLine">The Ritz-Carlton, Chicago</div>
              </div>

              <div className="home__heroRule home__heroRule--after" aria-hidden="true" />

              <div className="home__heroBrand" aria-label="Moet Hennessy USA">
                <div className="home__heroBrandName">Moët Hennessy</div>
                <div className="home__heroBrandSub">USA</div>
              </div>
            </div>

            {/* <div className="home__heroArtwork" aria-hidden="true">
              <div className="home__imagePlaceholder home__imagePlaceholder--hero">
                Image Placeholder
              </div>
            </div> */}
          </div>
        </section>

        <section className="home__section home__future">
          <div className="container home__sectionInner">
            <h2 className="home__sectionTitle">Welcome to the Future</h2>
            <p className="home__lead">
              This year&apos;s theme, Future Forward, reflects our desire to partner and
              redefine the future of luxury wines and spirits. The conference will bring
              our leadership teams and distributor partners together to connect, share
              perspectives, and align around shared priorities. We will elevate and set
              a higher standard.
            </p>

            <section className="home__expectPanel" aria-label="What to expect">
              <h3 className="home__panelTitle">What to Expect</h3>
              <ul className="home__expectGrid">
                {whatToExpect.map((item) => (
                  <li className="home__expectItem" key={item}>
                    {item}
                  </li>
                ))}
              </ul>
            </section>
          </div>
        </section>

        <section className="home__section home__planning">
          <div className="container home__sectionInner">
            <h2 className="home__sectionTitle">Registration Reminder &amp; Planning Guidance</h2>
            <p className="home__lead">
              Please review the information below as you finalize your registration,
              travel, and hotel accommodations for the 2026 MHUSA Distributor Conference.
            </p>

            <div className="home__planningPanel">
              <div className="home__planningGrid">
                <article className="home__planningCard home__planningCard--deadline">
                  <img
                    className="home__planningImg home__planningImg--tall"
                    src={laptopImage}
                    alt="Laptop on a desk"
                    loading="lazy"
                  />
                  <div className="home__deadlinePanel">
                    <h3 className="home__deadlineTitle">Registration Deadline</h3>
                    <p className="home__deadlineBody">
                      All distributor partners must register by February 16, 2026 to
                      confirm attendance.
                    </p>
                    <Link className="home__deadlineButton" to="/rsvp" target="_blank">
                      Register Now
                    </Link>
                  </div>
                </article>

                <article className="home__planningCard">
                  <img
                    className="home__planningImg home__planningImg--short"
                    src={bottlesImage}
                    alt="Bottles lineup"
                    loading="lazy"
                  />
                  <div className="home__planningBody">
                    <h3 className="home__cardTitle">Key Program Moments</h3>
                    <div className="home__cardDivider" aria-hidden="true" />

                    <dl className="home__moments">
                      {keyProgramMoments.map((moment) => (
                        <div className="home__moment" key={moment.date}>
                          <dt className="home__momentDate">{moment.date}</dt>
                          <dd className="home__momentDetail">{moment.detail}</dd>
                        </div>
                      ))}
                    </dl>

                    <p className="home__cardNote">
                      Attendees should plan travel and hotel stays to accommodate a
                      Thursday evening departure or later.
                    </p>
                  </div>
                </article>

                <article className="home__planningCard">
                  <img
                    className="home__planningImg home__planningImg--short"
                    src={venueImage}
                    alt="Venue interior"
                    loading="lazy"
                  />
                  <div className="home__planningBody">
                    <h3 className="home__cardTitle">Dress Code + Travel Info</h3>
                    <div className="home__cardDivider" aria-hidden="true" />

                    <div className="home__infoBlock">
                      <div className="home__infoLabel">Dress Code</div>
                      <p className="home__infoText">
                        Business attire throughout the conference; Cocktail attire for
                        Evening Ceremony. Please Note: jeans are not permitted.
                      </p>
                    </div>

                    <div className="home__infoRule" aria-hidden="true" />

                    <div className="home__infoBlock">
                      <div className="home__infoLabel">Hotel Accommodations</div>
                      <p className="home__infoText">
                        Please book your hotel by Monday, February 16, 2026.
                      </p>
                      <a
                        className="home__outlineButton"
                        href={HOTEL_BOOKING_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Book Hotel
                      </a>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </section>

        <section className="home__section home__questions">
          <div className="container home__sectionInner">
            <h2 className="home__sectionTitle">Questions?</h2>
            <p className="home__body">
              For questions related to registration, travel, or logistics, please contact:
              <br />
              <a href="mailto:distributorconference2026@moethennessy.com">
                distributorconference2026@moethennessy.com
              </a>
            </p>
          </div>
        </section>
      </main>
    </div>
  );
}
